<template>
    <div class="main-section">
        <img :src="require('@/assets/images/wm-promotion/main-section/1.png')" alt="" />
        <img :src="require('@/assets/images/wm-promotion/main-section/1-1.png')" alt="" />
    </div>
</template>

<script>
export default {
    name: 'Wm1',
}
</script>

<style scoped lang="scss"></style>
